import { ReactNode, useState, useEffect, useRef } from "react";

export default function InfoTile({
  className,
  children,
  image,
  IconclassName,
}: {
  className?: string;
  IconclassName?: string;
  children: ReactNode;
  image: string;
}) {
  return (
    <div
      className={`p-[12.5px] bg-[#FFF5ED] border-2 border-[#FFD3AD] rounded-xl flex items-center gap-2 ${className}`}
    >
      <div
        className={`bg-[#FF7700] !aspect-square w-[35px] flex justify-center items-center rounded-xl ${IconclassName}`}
      >
        <img src={image} />
      </div>
      <div>{children}</div>
    </div>
  );
}

export function InfoTileSketch({
  children,
  tileclassName,
}: {
  children: ReactNode;
  tileclassName: string;
}) {
  return (
    <div
      className={`bg-[#EEEEFF] md:px-14 py-2 w-20 flex flex-col justify-center items-center rounded-2xl border border-[#041C33]  ${tileclassName}`}
    >
      {children}
    </div>
  );
}

export function ExpandableTile({
  header,
  children,
  className,
  isPaid,
  quesClassName,
}: {
  header: string;
  children: ReactNode;
  className?: string;
  isPaid?: boolean;
  quesClassName?: string;
}) {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const onClick = () => {
    setIsExpanded(!isExpanded);
  };

  useEffect(() => {
    if (contentRef.current) {
      if (isExpanded) {
        contentRef.current.style.height = `${contentRef.current.scrollHeight}px`;
      } else {
        contentRef.current.style.height = "0px";
      }
    }
  }, [isExpanded]);

  return (
    <div
      className={`bg-[#F2F3F5] cursor-pointer w-full max-w-screen-lg rounded-lg transition-all ${className}`}
      onClick={onClick}
    >
      <div
        className={`flex justify-between items-center p-[17px] ${
          isExpanded ? `${quesClassName} rounded-t-lg` : ""
        }`}
      >
        <div>
          {!isPaid && <b>Q: </b>}
          {header}
        </div>
        <img src="/paid-long/gray-plus.png" alt="Expand/Collapse Icon"></img>
      </div>
      <div
        ref={contentRef}
        className={`overflow-hidden transition-height duration-300 ease-in-out`}
        style={{ height: "0px" }}
      >
        <div className="p-5 text-sm border-t bg-transparent">{children}</div>
      </div>
    </div>
  );
}
